export const CHART_COLORS = {
  primary: '#667eea',
  secondary: '#764ba2',
  success: '#34c759',
  warning: '#ff9500',
  danger: '#ff3b30',
  neutral: '#8e8e93',
  series: ['#667eea', '#34c759', '#ff9500', '#5856d6', '#00c7be', '#ff2d55', '#af52de', '#007aff'],
  gradient: {
    start: '#667eea',
    end: '#764ba2',
  },
};

export const ALERT_COLORS = {
  info: '#007aff',
  warning: '#ff9500',
  critical: '#ff3b30',
};

export const TREND_COLORS = {
  up: '#34c759',
  down: '#ff3b30',
  stable: '#8e8e93',
};
